<script>
    import mixin from './../mixin';
    import SourceSet from './SourceSet.vue';

    export default {
        emits: ['removeFavorite'],
        mixins: [mixin],
        components: { SourceSet },
        methods: {
            getShowLength(startDate, endDate) {
                if (!endDate) return null;
                const start = this.toDateObj(startDate);
                const end = this.toDateObj(endDate);
                let difference = end.getTime() - start.getTime();
                return Math.round(difference / 60000);
            }
        },
        props: {
            item: Object,
            langIso: {
                type: String,
                default: 'nl-NL'
            },
            favouriteTitleAdd: {
                type: String,
                default: 'Voeg toe aan favorieten'
            },
            favouriteTitleRemove: {
                type: String,
                default: 'Verwijder van favorieten'
            },
            isWishlist: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<template>
<div :class="['list-item-container', 'is-relative', item.imageSets.length ? '' : 'no-image']">
    <a :href="item.detailUrl" class="list-item-link"></a>
    <div class="is-flex is-block list-item">
        <template v-if="item.imageSets && item.imageSets.length">
            <div class="list-item-visual">
                <source-set :imageSets="item.imageSets" image-class="list-item-image has-shape-rounded"/>
                <time class="list-item-date" :datetime="item.startDate">
                    <span class="day">{{  toShortDayStr(item.startDate,langIso) }}</span>
                    <span class="date">{{ toDateStr(item.startDate,langIso) }}</span>
                    <span class="time">{{ toTimeStr(item.startDate,langIso) }}</span>
                </time>
            </div>
        </template>
        <time class="list-item-date" :datetime="item.startDate" v-else>
            <span class="day">{{  toShortDayStr(item.startDate,langIso) }}</span>
            <span class="date">{{ toDateStr(item.startDate,langIso) }}</span>
            <span class="time">{{ toTimeStr(item.startDate,langIso) }}</span>
        </time>
        <div class="list-item-info-wrapper">
            <div class="list-item-info">
                <button class="delete is-medium" v-if="isWishlist" :title="favouriteTitleRemove" @click.prevent="removeFromWishlist(item.id, item.name, toDateStr(item.startDate,langISO) + ' - ' + toTimeStr(item.startDate,langISO))"></button>
                <span :class="['wishlist-add', 'has-text-primary', 'wishlist-'+item.id, item.favorite ? 'is-active' : '']" :data-eventid="item.id" 
                                                                                                      :data-add="favouriteTitleAdd" 
                                                                                                      :data-remove="favouriteTitleRemove"
                                                                                                      :data-datetime="item.startDate"
                                                                                                      :title="item.favorite ? favouriteTitleRemove : favouriteTitleAdd" 
                                                                                                      :id="item.id"
                                                                                                      :data-productiontitle="item.name"
                                                                                                      :data-productionsubtitle="toDateStr(item.startDate,langIso) + ' - ' + toTimeStr(item.startDate,langIso)"
                                                                                                      @click.prevent.stop="addWishlistItem($event)" v-else>
                    <span class="icon">
                        <i class="fa-regular fa-heart fa-xl"></i>
                        <i class="fa-solid fa-heart fa-xl is-hidden"></i>
                    </span>
                </span>
                <div class="list-item-location" v-if="item.location && item.location.title">{{ item.location.title }}</div>
                <h3 class="list-item-title" v-if="item.name">{{ item.name }}</h3>
                <div class="list-item-subtitle" v-if="item.subtitle">{{ item.subtitle }}</div>
                <div class="list-item-genre" v-if="item.genre !== null && item.genre.title !== ''">{{item.genre.title}}</div>
                <div class="list-item-duration" v-if="item.showLength ">{{ item.showLength }}</div>
                <template v-if="item.orderButton">
                    <a :href="item.orderButton.url" class="button button-order list-item-button is-large is-primary is-rounded is-motionless" v-if="item.orderButton.clickable">
                        <span class="icon">
                            <i class="fa-solid fa-ticket fa-lg"></i>
                        </span>
                        <span>{{ item.orderButton.text }}</span>
                    </a>
                    <div class="button button-order list-item-button is-disabled is-large is-light is-rounded" v-else>{{ item.orderButton.text }}</div>
                </template>
            </div>
            <div class="list-item-extra" v-if="item.extra">{{ item.extra }}</div>
        </div>
    </div>
</div>
</template>
